export default __webpack_public_path__ + "static/media/iconDownload.37ba2a22.svg";